import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  pageListParams,
  pageListQueryOptions,
  pageListSearchSchema,
  PagesPage,
} from '@/features/pages';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/pages/')({
  staticData: { tours: ['content.pages'] },
  // Typed as the raw input so links into the list (`<Link to=".../content/pages">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    pageListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...pageListQueryOptions(params.storeId, pageListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: PagesPage,
});
